import { FC, useState } from 'react';

import { Document, Tags } from 'types';

import downloadDocument from 'utils/downloadDocument';

import documentTypes from 'constants/documentTypes';

import { ReplaceDocumentTagsSources } from 'modules/documents/api/replaceDocumentTags';

import { generateDocumentWithTags } from 'utils/generateDocumentWithTags';

import CustomLoading from '../../CustomLoading';

type DownloadDocumentProps = {
  document: Document;
  sources?: ReplaceDocumentTagsSources;
  tagsObject?: Tags;
  templateWatermarkText?: string;
  isLandscape?: boolean;
};

const DownloadDocument: FC<DownloadDocumentProps> = ({
  document,
  sources,
  templateWatermarkText,
  isLandscape, // TODO[MERGE]see this
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadTemplateDocument = async () => {
    await generateDocumentWithTags({
      documentId: document._id,
      documentName: document?.name || 'Template Document',
      sources: sources || {},
      language: 'es',
      footerHtml: '',
      watermarkText: templateWatermarkText,
    });
  };

  const handleDownloadRegularDocument = () => {
    downloadDocument({
      documentId: document?._id,
      documentName: document?.name,
      documents: [],
    });
  };

  const handleDownloadDocument = async () => {
    try {
      setIsLoading(true);
      if (document.category === documentTypes.TEMPLATES) {
        await handleDownloadTemplateDocument();
      } else {
        handleDownloadRegularDocument();
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-icon btn-trigger"
        onClick={handleDownloadDocument}
      >
        <em className="icon ni ni-file-download" />
      </button>

      {isLoading && <CustomLoading />}
    </>
  );
};

export default DownloadDocument;
